import React from 'react';
import { Box, Flex, Heading } from '@skin-seoul/design-system';
import { CLASSNAME, type CollectionIntroduction, type CollectionTerm } from '@skin-seoul/service';
import SectionContainer from '@/components/shared/SectionContainer';
import { getPageTitle } from '../../utils/titleHelpers';
import { type FilterOptions, type FilterSummary } from '../../types/filters';
import ReadMoreContent from '@/components/ui/ReadMoreContent/ReadMoreContent';
import CategorySlider from '../CategorySlider';
import CollectionIntroductionDesktopLayout from './CollectionIntroductionDesktopLayout';
interface CollectionIntroductionSectionProps {
  introduction?: CollectionIntroduction;
  category?: string;
  subcategory?: string;
  brand?: string;
  productTag?: string;
  searchQuery?: string;
  filterSummary?: FilterSummary;
  filters?: FilterOptions;
  sortBy?: string;
  collectionTerm?: CollectionTerm;
}
const CollectionIntroductionSection = ({
  introduction,
  category,
  subcategory,
  brand,
  productTag,
  searchQuery,
  filterSummary,
  filters,
  sortBy,
  collectionTerm
}: CollectionIntroductionSectionProps) => {
  if (!introduction?.body?.trim()) {
    return null;
  }
  const title = getPageTitle({
    searchQuery,
    collectionTerm,
    category,
    subcategory,
    brand,
    productTag,
    filterSummary,
    filters,
    sortBy
  });
  const isSubcategory = Boolean(subcategory);
  const IntroductionContent = () => <Box textStyle={{
    base: 'paragraph.small',
    tablet: 'paragraph.medium'
  }} fontWeight="regular" color="neutral.600" data-sentry-element="Box" data-sentry-component="IntroductionContent" data-sentry-source-file="CollectionIntroductionSection.tsx">
      <ReadMoreContent noOfLines={2} expandButtonText="more" collapseButtonText="less" ariaLabel="introduction text" data-sentry-element="ReadMoreContent" data-sentry-source-file="CollectionIntroductionSection.tsx">
        <div dangerouslySetInnerHTML={{
        __html: introduction.body
      }} />
      </ReadMoreContent>
    </Box>;
  return <Box width="100%" background="neutral.50" data-sentry-element="Box" data-sentry-component="CollectionIntroductionSection" data-sentry-source-file="CollectionIntroductionSection.tsx">
      <SectionContainer containerInnerProps={{
      paddingY: {
        base: 4,
        tablet: 9
      }
    }} data-sentry-element="SectionContainer" data-sentry-source-file="CollectionIntroductionSection.tsx">
        <Flex direction="column" gap={4} display={{
        base: 'flex',
        tablet: 'none'
      }} data-sentry-element="Flex" data-sentry-source-file="CollectionIntroductionSection.tsx">
          <Heading as="h1" textStyle="heading.h4" fontWeight="medium" color="neutral.700" className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Heading" data-sentry-source-file="CollectionIntroductionSection.tsx">
            {title}
          </Heading>
          <IntroductionContent data-sentry-element="IntroductionContent" data-sentry-source-file="CollectionIntroductionSection.tsx" />
          {!isSubcategory && <CategorySlider activeCategory={category} subcategory={subcategory} />}
        </Flex>

        {isSubcategory ? <Flex direction="column" gap={4} display={{
        base: 'none',
        tablet: 'flex'
      }}>
            <Heading as="h1" textStyle="heading.h2" fontWeight="medium" color="neutral.700" className={CLASSNAME.NOT_TRANSLATE}>
              {title}
            </Heading>
            <IntroductionContent />
          </Flex> : <CollectionIntroductionDesktopLayout title={title} introductionBody={introduction.body} category={category} subcategory={subcategory} />}
      </SectionContainer>
    </Box>;
};
export default CollectionIntroductionSection;